import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

const resetPageScroll = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

	// The app keeps <html> fixed and makes <body> the scroll container. iOS Safari
	// therefore ignores window.scrollTo(), so reset every possible scroll owner.
	const scrollContainers = [document.scrollingElement, document.documentElement, document.body];
	for (const container of scrollContainers) {
		if (!container) continue;
		container.scrollTop = 0;
		container.scrollLeft = 0;
	}
};

export default function ScrollToTop() {
	const { pathname, key } = useLocation();

	useEffect(() => {
		if ('scrollRestoration' in window.history) {
			const prev = window.history.scrollRestoration;
			window.history.scrollRestoration = 'manual';
			return () => {
				window.history.scrollRestoration = prev;
			};
		}
		return undefined;
	}, []);

	useLayoutEffect(() => {
		resetPageScroll();
		const frame = requestAnimationFrame(resetPageScroll);

		return () => cancelAnimationFrame(frame);
	}, [pathname, key]);

	return null;
}
